module.exports = __webpack_public_path__ + "img/xmg.0076a883.svg";